import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() currentPage: any;
  @Input() pages: any;
  @Input() visiblePages: any;
  more = "...";
  

  @Output() loadMoreData = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  getPages(pageNumber: any) {
    this.loadMoreData.emit(pageNumber);
  }

  getPageClasses(page: any): string {
    if (page === this.currentPage) {
      return 'page-item-active';
    } else if (page === '...') {
      return 'page-item-ellipsis';
    } else {
      return 'page-item';
    }
  }
  

}
